/* eslint-disable import/prefer-default-export */

import { getCookies } from '../api/api';
import { CookieParams } from '../types/PersonalData';
import { CryptoUtil } from './CryptoUtil';

export class CookieHelper {
  static setUserParams = (params: any) => {
    if (params && params.encodedTGT) {
      const cryptUserDataParams = CryptoUtil.encrypt(
        JSON.stringify({
          ...params,
        }),
      );
      const options = CookieHelper.getExpiresOption(false, { extricto: true });
      getCookies().set('userDataParams', cryptUserDataParams, options);
    }
  };

  static setFB = (fb: boolean) => {
    const options = CookieHelper.getExpiresOption(false, { extricto: false });
    getCookies().set('fb', fb.toString(), options);
  };

  static isBloqueada = () => {
    let fb;
    if (
      getCookies().get('fb') !== null &&
      getCookies().get('fb') !== undefined
    ) {
      fb =
        getCookies().get('fb') !== undefined ? getCookies().get('fb') : 'false';
    }
    return fb === 'true';
  };

  static getUserParams = () => {
    const cryptedUserParams = getCookies().get('userDataParams');
    return cryptedUserParams
      ? JSON.parse(CryptoUtil.decrypt(cryptedUserParams))
      : null;
  };

  static setCookieValue = (
    cookieName: string,
    cookieValue: string,
    params: CookieParams,
    recordar?: boolean,
  ) => {
    getCookies().remove(cookieName);
    const options = CookieHelper.getExpiresOption(recordar, params);
    getCookies().set(cookieName, cookieValue, options);
  };

  static setUserData = (objUser: any) => {
    getCookies().remove('userData');
    const cryptUserData = CryptoUtil.encrypt(
      JSON.stringify({
        ...objUser,
      }),
    );
    const options = CookieHelper.getExpiresOption(false, {
      extricto: true,
      secure: objUser,
    });
    getCookies().set('userData', cryptUserData, options);
  };

  static getUserData = () => {
    const cryptedUser = getCookies().get('userData');
    return cryptedUser ? JSON.parse(CryptoUtil.decrypt(cryptedUser)) : null;
  };

  static removeUserCookies = () => {
    getCookies().remove('userData');
  };

  static removeUserCookiesForLogout = () => {
    getCookies().remove('userData');
    getCookies().remove('userDataParams');
    getCookies().remove('token');
    getCookies().remove('i18n');
    getCookies().remove('i18next');
  };

  static renewTokenData = (token: string) => {
    const userData = CookieHelper.getUserData();
    if (userData) {
      userData.user.token = token;
      CookieHelper.setUserData(userData);
    }
  };

  static renewToken(token: string, isRecuerdame?: boolean) {
    const userParams = CookieHelper.getUserParams();
    const userData = CookieHelper.getUserData();
    // const userDataV = CookieHelper.getUserDataV();

    const options = CookieHelper.getExpiresOption(isRecuerdame, {
      extricto: true,
      secure: userParams,
    });

    CookieHelper.renewTokenData(token);
    getCookies().remove('userData');
    getCookies().remove('token');
    getCookies().remove('userDataParams');
    getCookies().set('token', token, options);
    getCookies().set(
      'userDataParams',
      CryptoUtil.encrypt(JSON.stringify(userParams)),
      options,
    );
    getCookies().set(
      'userData',
      CryptoUtil.encrypt(JSON.stringify(userData)),
      options,
    );
  }

  static setToken = async (token: string, isRecuerdame: boolean) => {
    const options = CookieHelper.getExpiresOption(isRecuerdame, {
      extricto: true,
    });
    getCookies().set('token', token, options);
  };

  private static getExpiresOption = (
    isRecuerdame: boolean | undefined,
    params: CookieParams,
  ) => {
    const isLocalhost = Boolean(
      process.env.NODE_ENV === 'development' &&
        window.location.protocol === 'http:' &&
        window.location.port === '3000' &&
        (window.location.hostname === 'privateac.eroski.es' ||
          window.location.hostname === 'privateac.caprabo.com'),
    );
    const seguridad = isLocalhost
      ? false
      : Boolean(process.env.REACT_APP_COOKIES_SECURE);

    const now = new Date();
    if (isRecuerdame) {
      now.setTime(now.getTime() + 365 * 24 * 60 * 60 * 1000);
    } else {
      now.setTime(now.getTime() + 60 * 1000);
    }
    return params.domain && params.domain.length > 0
      ? {
          expires: now,
          secure: seguridad,
          domain: params.domain,
          sameSite: 'Lax' as const,
        }
      : {
          expires: now,
          secure: seguridad,
          sameSite: params.extricto ? ('Strict' as const) : ('Lax' as const),
        };
  };
}
